import { useMatches } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useTranslation } from '@shared/i18n';

import { useAppMode } from 'component/root/AppModeProvider';

const ROCKET_SUFFIX = 'Rocket.net';

export const useSetRouteTitle = () => {
  const matches = useMatches();
  const { t } = useTranslation();
  const { isEmbedded } = useAppMode();

  useEffect(() => {
    // Find the deepest matched route with a routeTitle.
    // Child routes inherit an ancestor's title when they don't declare their own.
    const routeTitle = [...matches].reverse().find(m => m.staticData?.routeTitle)
      ?.staticData?.routeTitle;

    // Using `t` with a dynamic key is against the style guide but is intentional in this case.
    // Route titles are set with the t() from utils/routeTitle so the i18n linter registers them as used despite the dynamic usage here.
    const title = routeTitle ? t(routeTitle) : undefined;

    if (isEmbedded) {
      if (title) {
        document.title = title;
      }
    } else {
      document.title = title ? `${title} - ${ROCKET_SUFFIX}` : ROCKET_SUFFIX;
    }
  }, [matches, isEmbedded, t]);
};
